module.exports = __webpack_public_path__ + "static/media/tennis-ball.1d108f79.svg";